const state = {
  searchList: []
}

const getters = {
  searchList: (state) => state.searchList
}

const mutations = {
  SET_SEARCH_LIST(state, data) {
    state.searchList = data
    sessionStorage.setItem('searchList', JSON.stringify(data))
  }
}

const actions = {
  setSearchList({ commit }, data) {
    commit('SET_SEARCH_LIST', data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
